module.exports = __webpack_public_path__ + "static/media/drop-box-icon.954959d6.svg";